import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useInternalNavigate } from '../../../utils/navigate/useNavigate';
import { setQuoteResponse } from '../../../redux/slices/quoteResponseSlice';
import config from '../../../temp/config';
import { pushServiceDownError } from '../../../utils/analytics/datalayer';

const GetQuoteLogic = ({
  fields,
  quoteEndpoint,
  quoteData,
  utms,
  minDisplayTime,
  agentDetails,
}) => {
  const [hasComplete, setHasComplete] = useState(false);
  const [canClose, setCanClose] = useState(true);
  const dispatch = useDispatch();
  const navigate = useInternalNavigate();

  const formatDate = dateValue => {
    const [day, month, year] = dateValue.split('/');
    const date = new Date(`${year}-${month}-${day}`);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  };

  useEffect(() => {
    const submitQuoteRequest = (recaptchaToken = '') => {
      const requestBody = {
        requestDateTime: new Date(),
        recaptchaToken,
        requestedCoverStartDate: formatDate(quoteData.prospectDetails.coverStartDate),
        agencyCode: agentDetails.salesAgentCode,
        salesChannel: agentDetails.salesChannel,
        ...quoteData,
        urchinTrackingModule: utms,
      };

      if (minDisplayTime) {
        setCanClose(false);
        setTimeout(() => {
          setCanClose(true);
        }, minDisplayTime * 1000);
      }

      fetch(quoteEndpoint, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => {
          if (res.ok) {
            return res.json();
          } else {
            pushServiceDownError(quoteEndpoint, res);
            if (fields.serviceDownPage?.value?.href) {
              navigate(fields.serviceDownPage.value.href);
            }
          }
        })
        .then(data => {
          if (data) {
            if (data.shouldPreventSale) {
              navigate(fields.existingPlanPage.value.href);
            } else {
              dispatch(setQuoteResponse(data));
              setHasComplete(true);
            }
          }
        })
        .catch(err => {
          pushServiceDownError(quoteEndpoint, null, err);
          if (fields.serviceDownPage?.value?.href) {
            navigate(fields.serviceDownPage.value.href);
          }
        });
    };

    if (typeof window !== 'undefined' && config.recaptcha.toggle && window.grecaptcha) {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(config.recaptcha.sitekey, { action: 'submit' }).then(token => {
          submitQuoteRequest(token);
        });
      });
    } else {
      submitQuoteRequest();
    }
  }, []);

  useEffect(() => {
    if (hasComplete && canClose) {
      navigate(fields.redirectPage?.value?.href);
    }
  }, [hasComplete, canClose]);

  return <></>;
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    quoteEndpoint: state.appState?.config?.endpoints?.quotes,
    quoteData: state.quoteData,
    utms: state.utms,
    agentDetails: state.agentDetails,
  };
};
export default connect(mapStateToProps)(GetQuoteLogic);
